export default __webpack_public_path__ + "static/media/placeholder_store03-en-mobile.986052a3.png";